import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";
import {Colors} from "@Styles/Colors.style";

interface IconLengthIndicatorProps extends IconType {
    orientation?: "horizontal" | "vertical";
}

function IconLengthIndicator(props: IconLengthIndicatorProps) {
    const {
        width = "16",
        height = "16",
        fill = Colors.primaryColor,
        viewBox = "0 0 16 16",
        orientation = "horizontal",
        ...rest
    } = props

    const rotate = {
        horizontal: "0deg",
        vertical: "90deg",
    }

    const style = {transform: `rotate(${rotate[orientation]})`}

    return (
        <GenericSvgIcon
            {...{width, height, viewBox, style, ...rest}}
            svgIconPath={(
                <g fill={fill} transform="translate(.5028 4.5714)">
                    <path d="m7.497172 2.729491h-7.493754v1.39863h7.493754c0-.5462 0-.85243 0-1.39863z"/>
                    <path
                        d="m.003418 2.729491c2.314214 0 4.194234 1.84409 4.194234 4.12758h-1.39863c0-1.50497-1.24789-2.72895-2.795604-2.72895z"
                    />
                    <path
                        d="m4.194122 0c0 2.283501-1.87991 4.127661-4.194122 4.127661v-1.39863c1.547722 0 2.795492-1.22404 2.795492-2.729031z"
                    />
                    <path d="m7.497172 4.128121 7.49372.00019v-1.39863l-7.49372-.00019z"/>
                    <path
                        d="m12.195492 0c0 1.505011 1.2477 2.729681 2.7954 2.729681v1.39863c-2.3142 0-4.194-1.84478-4.194-4.128311z"
                    />
                    <path
                        d="m14.994392 2.729491v1.39863c-1.5477 0-2.7954 1.22407-2.7954 2.72905h-1.3987c0-2.28349 1.8799-4.12768 4.1941-4.12768z"
                    />
                </g>
            )}
        />
    )
}

export default IconLengthIndicator;